<template>
	<div class="relative w-full">
		<div
			v-if="showPrimaryImage"
			class="aspect-h-2 aspect-w-3 cursor-pointer overflow-hidden"
		>
			<CarbarImage
				:image="product.primary_image"
				:alt-text="
					product.primary_image_alt_text ??
					`${product.year} ${product.make} ${product.model} image`
				"
				image-width="w-full"
				image-height="h-full"
				class="pointer-events-none"
				style-str="transform: translate3d(0, 0, 1px);"
			/>
		</div>

		<div v-else-if="showCarousel">
			<Carousel
				:class="`m-0 p-0`"
				:mouse-drag="false"
				:touch-drag="false"
				:wrap-around="true"
				width="300"
				height="200"
				style="width: 100%; height: auto"
			>
				<Slide v-for="image in thumbnails" :key="image">
					<div
						class="carousel__item aspect-h-2 aspect-w-3 flex w-full cursor-pointer items-center justify-center"
					>
						<CarbarImage
							:image="image.file_path"
							:alt-text="image.alt_text ?? 'vehicle image'"
							class="pointer-events-none"
							style-str="width: 100%; height: auto"
						/>
					</div>
				</Slide>

				<template #addons>
					<div
						v-if="showSlideArrows"
						class="carousel-navigation carousel-navigation--show-on-hover duration-200"
					>
						<Navigation />
					</div>
				</template>
			</Carousel>
		</div>

		<div v-else class="aspect-h-2 aspect-w-3 h-auto w-full cursor-pointer">
			<CarbarImage
				image="img/product-catalog/img-comingsoon.webp"
				alt-text="Coming soon"
				sizes="360px lg:450px"
				densities="x1 x2"
			/>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import CarbarImage from '@/components/CarbarImage.vue'

const props = defineProps({
	product: {
		type: Object,
		required: true,
	},
	showSlideArrows: {
		type: Boolean,
		required: true,
	},
})

const thumbnails = computed(() =>
	props.product.images?.filter((image) => image.thumbnail)
)

const showPrimaryImage = computed(
	() => props.product.primary_image && !props.showSlideArrows
)
const showCarousel = computed(
	() => thumbnails.value && thumbnails.value.length && props.showSlideArrows
)
</script>
